export default __webpack_public_path__ + "static/media/confirm_pw.a18e427d.svg";